;(function (window, APP, Backbone, Marionette, $, _) {
	'use strict';

	var View = APP.module('View');

	View.TippingLeaguesJoinFilter = View.LeaguesJoinFilter.extend({
		template: JST.TippingLeaguesJoinFilter,
		ui: {
			'private_input':  '.js-private-input',
			'private_submit': '.js-private-submit',
			'public_input':   '.js-public-input',
			'public_submit':  '.js-public-submit'
		}
	});

}(window, APP, Backbone, Marionette, $, _));